const livingFace = {
  state: {
    myLivingFaceImgUrl: '',
    myLivingFacePopupStatus: false,
    myLivingFaceAccessToken: '',
    myLivingFaceCustomerId: '',
    myLivingFaceVerifyType: 0,
    myLivingFaceType: 0,
  },
  getters: {
    livingFaceImgUrl: state => {
      return state.myLivingFaceImgUrl;
    },
    livingFacePopupStatus: state => {
      return state.myLivingFacePopupStatus;
    },
    livingFaceAccessToken: state => {
      return state.myLivingFaceAccessToken;
    },
    livingFaceCustomerId: state => {
      return state.myLivingFaceCustomerId;
    },
    livingFaceVerifyType: state => {
      return state.myLivingFaceVerifyType;
    },
    livingFaceType: state => {
      return state.myLivingFaceType;
    },
  },
  mutations: {
    setLivingFaceImgUrl: (state, val) => {
      state.myLivingFaceImgUrl = val;
    },
    setLivingFacePopupStatus: (state, val) => {
      state.myLivingFacePopupStatus = val;
    },
    setLivingFaceAccessToken: (state, val) => {
      state.myLivingFaceAccessToken = val;
    },
    setLivingFaceCustomerId: (state, val) => {
      state.myLivingFaceCustomerId = val;
    },
    setLivingFaceVerifyType: (state, val) => {
      state.myLivingFaceVerifyType = val;
    },
    setLivingFaceType: (state, val) => {
      state.myLivingFaceType = val;
    },
  }
}

export default livingFace;